import { Brand } from '@src/Branding';
import AxysLogo from '@src/common/assets/axys-logo.svg?react';
import NovaLogo from '@src/common/assets/company-logo.svg?react';
import NavigatorLogo from '@src/common/assets/navigator-logo.svg?react';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import Config from '@src/config/Config';

export const LogoAndTitle = ({
  height,
  width,
}: {
  height?: number;
  width?: number;
}) => {
  const brand = Config.VITE_BRAND;

  return (
    <Stack direction="row" justifyContent="space-between">
      <NavigatorLogo height={height} width={width} />

      <Divider orientation="vertical" />

      {brand === Brand.Axys ? (
        <AxysLogo height={height} width={width} />
      ) : (
        <NovaLogo height={height} width={width} />
      )}
    </Stack>
  );
};
